import { useState, useEffect } from 'react';
import { usePlatformCheck } from '@usap/core'

const useGPaySupported = () => {
    const [isGPaySupport, setIsGPaySupport] = useState(true);
    const { platform, isMobile } = usePlatformCheck()

    useEffect(() => {
        if (typeof window !== 'undefined') {
            // Disable GPay on iOS Flutter apps
            if (platform === "ios" && isMobile) {
                setIsGPaySupport(false);
            }
        }
    }, [platform, isMobile]);

    return isGPaySupport;
};

export default useGPaySupported;